import React from "react";

const ArrowLeft = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    >
      <path d="M22 12H2M9 19l-7-7 7-7" />
    </g>
  </svg>
);

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/theme/icons/ArrowLeft.js